// extracted by mini-css-extract-plugin
var _1 = "servicesSection-module__servicesSectionContent___fHgN6";
export { _1 as "servicesSectionContent" }
